import { TypographyStyles } from '@/styles'
import { Accordion, Button, Card, Icon, Text, Image, CardColors } from '@/ui'
import { light } from '@fortawesome/fontawesome-svg-core/import.macro'
import React from 'react'
import { useNavigate } from 'react-router-dom'

interface TaxesSuccessHeaderCardProps {
  imageSrc: string
  title: string
  description: React.ReactNode
  buttonText: string
  onButtonClickTo: string
  note?: React.ReactNode
  accordionContent?: {
    title: string
    content: React.ReactNode
  }
}

export const TaxesSuccessHeaderCard = ({
  imageSrc,
  title,
  description,
  buttonText,
  onButtonClickTo,
  note,
  accordionContent,
}: TaxesSuccessHeaderCardProps) => {
  const navigate = useNavigate()
  return (
    <Card color={CardColors.LEVEL_1}>
      <div className="space-y-5">
        <Image src={imageSrc} alt="Tax form illustration" className="w-full" />

        <div className="space-y-5">
          <Text variant={TypographyStyles.H3}>{title}</Text>

          <Text>{description}</Text>

          {note && (
            <Text variant={TypographyStyles.BODY_XS} className="mt-5">
              {note}
            </Text>
          )}

          <Button
            variant="primary"
            size="md"
            className="mt-5"
            onClick={() => navigate(onButtonClickTo)}
          >
            {buttonText}
            <Icon icon={light('arrow-right')} className="ml-2" />
          </Button>

          {accordionContent && (
            <Accordion variant="text" type="single" collapsible>
              <Accordion.Item value="item-1">
                <Accordion.Trigger>{accordionContent.title}</Accordion.Trigger>
                <Accordion.Content>
                  {accordionContent.content}
                </Accordion.Content>
              </Accordion.Item>
            </Accordion>
          )}
        </div>
      </div>
    </Card>
  )
}
